/* svw-hub.js: Reseller Hub behaviour (DECISION 5, 9; SPEC 11). Node exports for test_hubjs.cjs. */
(function (G, make) {
  const H = make(G);
  if (typeof module === 'object' && module.exports) module.exports = H;
  else if (G.document && !G.SVWHub) H.boot();
})(typeof window !== 'undefined' ? window : {}, function (W) {
'use strict';

const KEY = 'svw_hub_v1', VKEY = 'svw_hub_view', MON = 'Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec'.split(' ');
const BADK = /^(__proto__|constructor|prototype)$/, WORD = { new: 'Not started', started: 'In progress', done: 'Done' };
const isObj = o => !!o && typeof o === 'object' && !Array.isArray(o);
const keys = o => Object.keys(o || {}).filter(k => !BADK.test(k));
const clamp = (n, a, b) => Math.min(b, Math.max(a, n));
const pad2 = n => String(n).padStart(2, '0');
const fresh = () => ({ v: 1, lessons: {}, last: null, checks: {}, patches: [], saved: {} });
const withQ = (b, qs) => b + (b.indexOf('?') > -1 ? '&' : '?') + qs;
const schoolOf = x => ((x && x.lessons) || []).filter(l => l.kind === 'lesson').sort((a, b) => a.order - b.order);
const canView = (mode, ent) => mode === 'preview' && ent === 'no';
const viewOf = get => { try { return get() === 'pass' ? 'pass' : 'visitor'; } catch (e) { return 'visitor'; } };
const partsLabel = n => n + (n === 1 ? ' part' : ' parts');
// Data without free flags locks nothing.
const lockOf = a => { const f = (a || []).some(x => x && x.free != null); return x => f && x.free !== true; };

function fmtDate(v) {
  if (typeof v === 'number') { const d = new Date(v); return isNaN(d) ? '' : d.getDate() + ' ' + MON[d.getMonth()] + ' ' + d.getFullYear(); }
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(v || '');
  return m ? +m[3] + ' ' + MON[m[2] - 1] + ' ' + m[1] : '';
}

function parse(raw) {
  const st = fresh(), each = (o, f) => isObj(o) && keys(o).forEach(k => f(k, o[k]));
  if (raw == null || raw === '') return { st, bad: false };
  let o = null;
  try { o = JSON.parse(raw); } catch (e) { /* bad */ }
  if (!isObj(o) || o.v !== 1) return { st, bad: true };
  each(o.lessons, (id, l) => { if (isObj(l) && (l.s === 'started' || l.s === 'done')) st.lessons[id] = { s: l.s, pct: clamp(Math.round(+l.pct || 0), 0, 100), at: +l.at > 0 ? +l.at : 0 }; });
  each(o.checks, (k, a) => { if (Array.isArray(a)) st.checks[k] = a.filter(n => Number.isInteger(n) && n >= 0 && n < 1000); });
  each(o.saved, (k, a) => { if (Array.isArray(a)) st.saved[k] = a.filter(x => isObj(x) && isObj(x.in)).slice(-20); });
  if (typeof o.last === 'string' && !BADK.test(o.last)) st.last = o.last.slice(0, 80);
  if (Array.isArray(o.patches)) st.patches = o.patches.filter(n => Number.isInteger(n) && n > 0 && n < 50);
  return { st, bad: false };
}

function mkStore(getLS, now) {
  now = now || Date.now;
  let ls = null, ok = false, raw = null, mem = false, dirty = false, lastW = 0, timer = 0;
  try { ls = getLS(); ls.setItem(KEY + '_probe', '1'); ls.removeItem(KEY + '_probe'); ok = true; } catch (e) { ok = false; }
  if (ok) { try { raw = ls.getItem(KEY); } catch (e) { ok = false; } }
  let { st, bad } = parse(raw);
  const flush = () => {
    clearTimeout(timer); timer = 0;
    if (!dirty || mem || !ok) return;
    dirty = false; lastW = now();
    try { ls.setItem(KEY, JSON.stringify(st)); bad = false; } catch (e) { ok = false; }
  };
  return {
    ok: () => ok, bad: () => bad, qa: () => mem, raw: () => st, flush, get: () => JSON.parse(JSON.stringify(st)),
    set(fn) {
      try { fn(st); } catch (e) { /* never breaks the page */ }
      if (mem || !ok) return;
      dirty = true;
      const wait = 2000 - (now() - lastW);
      if (wait <= 0) flush(); else if (!timer) timer = setTimeout(flush, wait);
    },
    load(o) { mem = true; dirty = false; st = parse(JSON.stringify(o)).st; }
  };
}

function pickResume(st, sc, by) {
  if (!sc.length) return { mode: 'new', id: null };
  if (sc.every(l => by[l.id] === 'done')) return { mode: 'all', id: null };
  let best = null, at = -1, hi = -1;
  sc.forEach((l, i) => {
    if (by[l.id] === 'started' && st.lessons[l.id].at > at) { at = st.lessons[l.id].at; best = l.id; }
    if (by[l.id] === 'done') hi = i;
  });
  if (best) return { mode: 'resume', id: best, pct: st.lessons[best].pct };
  if (hi < 0) return { mode: 'new', id: sc[0].id };
  return { mode: 'next', id: sc.slice(hi + 1).concat(sc.slice(0, hi + 1)).find(l => by[l.id] !== 'done').id };
}

function derive(st, x) {
  const L = (x && x.lessons) || [], sc = schoolOf(x), by = {}, cnt = (ids, s) => ids.filter(id => by[id] === s).length;
  L.forEach(l => { by[l.id] = st.lessons[l.id] ? st.lessons[l.id].s : 'new'; });
  const levels = ((x && x.levels) || []).map(lv => {
    const ids = sc.filter(l => l.level === lv.n).map(l => l.id), done = cnt(ids, 'done');
    return { n: lv.n, ids, total: ids.length, done, state: ids.length && done === ids.length ? 'done' : done || cnt(ids, 'started') ? 'started' : 'new' };
  });
  const done = cnt(sc.map(l => l.id), 'done');
  return { by, levels, done, total: sc.length, fr: sc.length ? (done / sc.length).toFixed(3) : '0', resume: pickResume(st, sc, by),
    progress: !L.some(l => by[l.id] !== 'new') ? 'none' : sc.length && done === sc.length ? 'all' : 'some',
    here: by[st.last] === 'started' && sc.some(l => l.id === st.last) ? st.last : null };
}

const norm = s => String(s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
const toks = s => norm(s).split(' ').filter(Boolean).slice(0, 8).map(w => (w.length > 3 && /[^s]s$/.test(w) ? w.slice(0, -1) : w));
const GW = { lesson: 4, playbook: 4, tool: 4, term: 3 };
const GROUPS = { lesson: 'Lessons', section: 'Lesson sections', tool: 'Tools', playbook: 'Playbooks', term: 'Glossary terms' }, KIND = { lesson: 'Lesson', section: 'Section', tool: 'Tool', playbook: 'Playbook', term: 'Term', page: 'Page' };

// p: Pass content (a locked lesson's first section is its free teaser).
function buildIndex(data, hp) {
  const out = [], L = data.lessons || [], T = data.tools || [], lkL = lockOf(L), lkT = lockOf(T);
  const add = (g, f, t, s, u, k, p) => out.push({ g, f, t, s: s || '', u, n: norm(t), ns: norm(s), nk: norm(k), p: !!p });
  L.forEach(l => {
    const f = l.kind === 'platform' ? 'playbook' : 'lesson', p = lkL(l);
    add(f, f, l.title, l.summary, hp + l.id, (l.keys || []).join(' '), p);
    (l.sections || []).forEach((s, i) => add('section', f, s.text, 'In ' + l.title, hp + l.id + '#' + s.id, '', p && i > 0));
  });
  T.forEach(t => add('tool', 'tool', t.title, t.summary || 'In the Toolkit', hp + 'tools#' + t.id, (t.keys || []).join(' '), lkT(t)));
  (data.glossary || []).forEach(g => add('term', 'term', g.term, g.def, hp + 'glossary#' + g.id, g.section));
  return out;
}

function score(it, ts, qn) {
  const ws = (f, t) => (' ' + f).indexOf(' ' + t) > -1, has = (f, t) => f.indexOf(t) > -1;
  let sc = 0;
  for (const t of ts) {
    const b = ws(it.n, t) ? (it.n.indexOf(t) ? 12 : 16) : t.length > 2 && has(it.n, t) ? 8 : ws(it.nk, t) ? 6 : ws(it.ns, t) ? 3 : t.length > 3 && (has(it.nk, t) || has(it.ns, t)) ? 2 : 0;
    if (!b) return 0;
    sc += b;
  }
  if (it.n === qn) sc += 40; else if (!it.n.indexOf(qn)) sc += 20; else if (ts.length > 1 && has(it.n, qn)) sc += 10;
  if (ts.length > 1 && has(it.nk, qn)) sc += 8;
  return sc + (GW[it.g] || 0);
}

function search(items, qv, f) {
  const ts = toks(qv), qn = ts.join(' '), cap = f === 'all' ? { lesson: 5, section: 5, tool: 4, playbook: 4, term: 6 } : null, hits = [], by = {}, order = [];
  items.forEach(it => {
    if ((f !== 'all' && it.f !== f) || (!ts.length && it.g === 'section')) return;
    const sc = ts.length ? score(it, ts, qn) : 1;
    if (sc) hits.push({ it, sc });
  });
  if (ts.length) hits.sort((a, b) => b.sc - a.sc);
  hits.forEach(({ it }) => {
    if (!by[it.g]) order.push(by[it.g] = { g: it.g, label: GROUPS[it.g], items: [] });
    if (by[it.g].items.length < (cap ? cap[it.g] : 30)) by[it.g].items.push(it);
  });
  return order;
}

function ranges(text, ts) {
  const low = String(text).toLowerCase(), r = [], m = [];
  ts.forEach(t => {
    for (let i = low.indexOf(t); i > -1; i = low.indexOf(t, i + t.length)) if (t.length > 1 || !i || /[^a-z0-9]/.test(low[i - 1])) r.push([i, i + t.length]);
  });
  r.sort((a, b) => a[0] - b[0]).forEach(x => { const l = m[m.length - 1]; if (l && x[0] <= l[1]) l[1] = Math.max(l[1], x[1]); else m.push(x.slice()); });
  return m;
}

function qaState(v, x) {
  const st = fresh(), now = Date.now(), sc = schoolOf(x);
  if (v === 'new') return st;
  sc.forEach((l, i) => { if (v === 'all' || i < 5) st.lessons[l.id] = { s: 'done', pct: 100, at: now - (30 - i) * 864e5 }; });
  if (v === 'mid' && sc[5]) { st.lessons[sc[5].id] = { s: 'started', pct: 42, at: now }; st.last = sc[5].id; st.patches = [1]; }
  if (v === 'all') st.patches = ((x && x.levels) || []).map(l => l.n);
  return st;
}

const glossAsk = (v, def) => { v = String(v || '').trim().slice(0, 80); return v ? 'What does "' + v + '" mean in reselling?' : def; };

const D = W.document, PASS = { passive: true }, nop = () => {};
let R, idx = {}, store, byId = {}, hp = '', hh = '', bob = false, lid = null, toastEl, toastT = 0, reduce, mqPhone, mqDesk, rco, realign = nop;
let view = 'visitor', toolsReq = false, tocScan = nop, fadeWatch = nop, tickL = nop;
const q = (s, r) => (r || D).querySelector(s), qa = (s, r) => Array.from((r || D).querySelectorAll(s)), each = (s, f) => qa(s, R).forEach(f);
const once = (s, k, f) => each(s, e => { if (!e[k]) { e[k] = 1; f(e); } });
const on = (e, t, f, o) => e && e.addEventListener(t, f, o);
const sa = (e, k, v) => e.setAttribute(k, v), ga = (e, k) => e.getAttribute(k), ra = (e, k) => e.removeAttribute(k);
// Write only on change (7.3).
const sx = (e, k, v) => { if (e && ga(e, k) !== v) sa(e, k, v); };
const hid = (e, v) => { if (e && e.hidden !== v) e.hidden = v; };
const setP = (e, v) => { if (e && e.style.getPropertyValue('--p') !== v) e.style.setProperty('--p', v); };
// Without preference consent, scrolling alone saves nothing.
const prefOK = () => { try { const P = W.Shopify && W.Shopify.customerPrivacy; return !P || !P.preferencesProcessingAllowed || !!P.preferencesProcessingAllowed(); } catch (e) { return true; } };
const mq = s => (W.matchMedia ? W.matchMedia(s) : { matches: false });
const onMq = (m, f) => (m.addEventListener ? m.addEventListener('change', f) : m.addListener && m.addListener(f));
const hit = (e, s) => (e.target && e.target.closest ? e.target.closest(s) : null);
const pass = () => ga(R, 'data-hub-entitled') === 'yes' || view === 'pass';
const full = () => pass() || !/^(locked|preview)$/.test(ga(R, 'data-hub-gate'));
const barH = () => { const b = q('.hub-bar', R); return b ? b.offsetHeight : 0; };
const num = v => { const n = parseFloat(String(v == null ? '' : v).replace(/[\u00a3,\s]/g, '')); return isFinite(n) ? n : NaN; };
const tget = e => (e ? (q('[data-hub-t]', e) || e).textContent.trim() : '');
const idOf = a => D.getElementById(decodeURIComponent((ga(a, 'href') || '').slice(1)));
function el(tag, cls, text, at) {
  const e = D.createElement(tag);
  if (cls) e.className = cls; if (text != null) e.textContent = text;
  Object.keys(at || {}).forEach(k => sa(e, k, at[k])); return e;
}
function svg(cls, child, at) {
  const NS = 'http://www.w3.org/2000/svg', s = D.createElementNS(NS, 'svg'), c = s.appendChild(D.createElementNS(NS, child));
  sa(s, 'class', cls); sa(s, 'aria-hidden', 'true'); sa(s, 'focusable', 'false');
  Object.keys(at).forEach(k => sa(c, k, at[k]));
  return s;
}
function tset(e, s) {
  if (!e) return;
  const t = q('[data-hub-t]', e) || (e.children.length ? null : e), n = t ? null : Array.from(e.childNodes).filter(x => x.nodeType === 3 && x.nodeValue.trim()).pop();
  if (t) { if (t.textContent !== s) t.textContent = s; } else if (n) { if (n.nodeValue !== s) n.nodeValue = s; } else e.appendChild(el('span', null, s, { 'data-hub-t': '' }));
}
function raf(f) { let p = 0; return () => { if (!p) { p = 1; requestAnimationFrame(() => { p = 0; f(); }); } }; }
// After the browser's own layout, so boot forces none (7.3).
function afterLayout(f) {
  if (!W.ResizeObserver) return void raf(f)();
  const o = new ResizeObserver(() => { o.disconnect(); f(); }); o.observe(R);
}
function toast(m) {
  toastEl.textContent = m; toastEl.classList.add('is-on'); clearTimeout(toastT);
  toastT = setTimeout(() => { toastEl.classList.remove('is-on'); toastT = setTimeout(() => { toastEl.textContent = ''; }, 300); }, 3000);
}
// Focus f without the jump; scroll `a` below the bar and `b` into view.
function bring(a, b, f) {
  if (f) { if (!f.hasAttribute('tabindex')) sa(f, 'tabindex', '-1'); f.focus({ preventScroll: true }); }
  if (!a || !a.getClientRects().length) return;
  const t = a.getBoundingClientRect().top, lim = barH() + 16;
  if (t < lim || (b || a).getBoundingClientRect().bottom > innerHeight) W.scrollTo({ top: Math.max(0, t + W.pageYOffset - lim), behavior: reduce.matches ? 'auto' : 'smooth' });
}
function ask(t, lesson) {
  t = String(t || '').trim().slice(0, 500);
  if (bob && t) try { lesson ? W.SVWBob.chat.send(t, { lesson: lesson }) : W.SVWBob.chat.send(t); } catch (e) { /* Bob's */ }
}
const askText = b => { const f = ga(b, 'data-hub-ask-from'), fi = f && q(f, R); return glossAsk(fi && fi.value, ga(b, 'data-hub-ask')); };
// Never inside a Pass-only block without the Pass.
const revealAsk = () => bob && each('[data-hub-askrow], .hub-ask', e => hid(e, !pass() && !!e.closest('[data-hub-paid]')));
function mkDlg(cls, at, title) {
  let opener = null;
  const d = R.appendChild(el('dialog', cls, null, at)), box = d.appendChild(el('div', cls + '__box')), head = box.appendChild(el('div', cls + '__head')), x = el('button', cls + '__close', 'Close', { type: 'button' });
  if (title) head.appendChild(el('h2', cls + '__h', title, { id: cls + '-h' }));
  head.appendChild(x);
  on(x, 'click', () => d.close()); on(d, 'click', e => { if (e.target === d) d.close(); });
  on(d, 'close', () => { if (opener && opener.isConnected) opener.focus(); opener = null; });
  return { d, box, head, drop: () => { opener = null; }, open(src) { opener = src || D.activeElement; try { d.showModal(); } catch (e) { sa(d, 'open', ''); } } };
}

const rg = c => q('.hub-resume__' + c, R);
function renderResume(d) {
  if (!rco) return;
  const r = d.resume, L = byId[r.id], go = rg('go'), tape = rg('tape'), v = Object.assign({}, rco), none = d.progress === 'none', all = !none && r.mode === 'all';
  if (!none) {
    v.note = 'Saved on this device only. No account, nothing sent.';
    if (all) Object.assign(v, { k: 'School complete', n: String(d.total), t: 'Every lesson done. Nice work.', m: d.levels.length + ' levels, ' + d.total + ' lessons', gt: 'Read the playbooks', gh: hh + '#playbooks' });
    else if (L && r.mode !== 'new') {
      const res = r.mode === 'resume';
      Object.assign(v, { k: res ? 'Pick up where you left off' : 'Up next', n: pad2(L.order), t: L.title, gh: hp + L.id,
        m: 'Level ' + L.level + ', ' + (res ? (r.pct || 0) + '% read, ' : '') + L.minutes + ' min', gt: (res ? 'Continue lesson ' : 'Start lesson ') + pad2(L.order) });
    }
  }
  ['k', 'n', 't', 'm', 'note'].forEach(c => tset(rg(c), v[c]));
  if (go) { tset(go, v.gt); if (v.gh) sx(go, 'href', v.gh); }
  if (tape) { hid(tape, none); setP(tape, d.fr); tset(rg('done') || tape, d.done + ' of ' + d.total + ' done'); }
  hid(rg('alt'), !all);
  hid(rg('reset'), none);
}

function render() {
  const st = store.raw(), d = derive(st, idx), ok = store.ok(), bp = q('.hub-bar__prog', R), none = d.progress === 'none', pt = d.done + ' of ' + d.total + ' done';
  const lvOf = e => d.levels.find(l => String(l.n) === (ga(e, 'data-level') || ga(e, 'data-hub-levelprog')));
  sx(R, 'data-hub-progress', d.progress);
  if (bp) { hid(bp, none); setP(bp, d.fr); tset(q('[data-hub-progtext]', bp) || bp, pt); sx(bp, 'aria-label', 'School progress: ' + pt); }
  each('[data-hub-card]', c => {
    const id = ga(c, 'data-hub-card'), s = d.by[id];
    if (!s) return;
    sx(c, 'data-state', s);
    if (id === d.here) sx(c, 'data-here', 'true'); else ra(c, 'data-here');
    tset(q('[data-hub-state]', c), ok ? WORD[s] : '');
  });
  each('.hub-map__level[data-level]', e => { const lv = lvOf(e); if (lv) sx(e, 'data-state', lv.state); });
  each('[data-hub-levelprog]', e => {
    const lv = lvOf(e), sig = lv && !none ? lv.ids.map(id => d.by[id]).join() : '';
    if (e.hubSig === sig) return;
    e.hubSig = sig; e.textContent = '';
    if (!sig) return;
    const segs = el('span', 'hub-map__segs', null, { 'aria-hidden': 'true' });
    lv.ids.forEach(id => segs.appendChild(el('i', null, null, { 'data-s': d.by[id] })));
    e.append(segs, el('span', 'hub-map__lvt', lv.done + ' of ' + lv.total + ' done'));
  });
  each('.hub-patch[data-level]', e => {
    const lv = lvOf(e), w = lv && (lv.state === 'done' ? 'Complete' : lv.state === 'started' ? lv.done + ' of ' + lv.total : 'Not started');
    if (!lv) return;
    sx(e, 'data-state', lv.state);
    tset(q('[data-hub-state], .hub-patch__state', e), w);
    let sr = q('.hub-patch__sr', e);
    if (!sr) { qa('.hub-patch__name, .hub-patch__state', e).forEach(x => sa(x, 'aria-hidden', 'true')); sr = e.appendChild(el('span', 'hub-patch__sr visually-hidden')); }
    tset(sr, tget(q('.hub-patch__name', e)) + ', ' + w + (lv.state === 'started' ? ' done' : ''));
    if (lv.state === 'done' && st.patches.indexOf(lv.n) < 0 && ok && !store.qa() && prefOK()) { if (!reduce.matches) e.classList.add('is-sewn-now'); store.set(s => { s.patches.push(lv.n); }); }
  });
  renderResume(d);
  if (lid) sx(q('.hub-done__btn', R), 'aria-pressed', String(d.by[lid] === 'done'));
  each('[data-hub-checklist]', box => {
    const set = st.checks[ga(box, 'data-hub-checklist')] || [], all = qa('.hub-check__box', box);
    all.forEach((c, i) => { const v = set.indexOf(+(ga(c, 'data-i') || i)) > -1; if (c.checked !== v) c.checked = v; });
    const n = all.filter(c => c.checked).length;
    tset(q('[data-hub-checkcount]', box), (n && n === all.length ? 'All ' + n : n + ' of ' + all.length) + ' ticked.' + (ok ? ' Saved on this device only.' : ''));
  });
  renderSaved();
}

function renderSaved() {
  const box = q('[data-hub-saved]', R), ul = q('[data-hub-saved-list]', R), sv = store.raw().saved;
  if (!box || !ul) return;
  ul.textContent = '';
  keys(sv).forEach(k => sv[k].forEach((x, i) => {
    const tool = (idx.tools || []).find(t => t.id === k), name = tool ? tool.title : k, rm = el('button', 'hub-btn hub-btn--link hub-saved__rm', 'Remove', { type: 'button', 'aria-label': 'Remove ' + name + ' result' });
    ul.appendChild(el('li', 'hub-saved__item')).append(el('span', 'hub-saved__t', name + (x.at ? ', saved ' + fmtDate(x.at) : '')), ' ', el('span', 'hub-saved__s', String(x.sum || '').slice(0, 240)), ' ', rm);
    on(rm, 'click', () => {
      store.set(s => { const a = s.saved[k]; if (a) { a.splice(i, 1); if (!a.length) delete s.saved[k]; } });
      render(); toast('Removed from this device');
      const f = box.hidden ? box.parentElement : q('.hub-saved__h', box) || box;
      if (f) bring(f, null, f);
    });
  }));
  hid(box, !ul.children.length);
}

function setOpen(lv, open) {
  const b = q('.hub-map__toggle', lv), ol = q('.hub-map__lessons', lv);
  if (!b) return;
  sa(lv, 'data-open', String(open)); sa(b, 'aria-expanded', String(open));
  if (ol) ol.hidden = !open;
}
function openDefaults() {
  const d = derive(store.raw(), idx), nf = d.levels.find(l => l.state !== 'done'), def = byId[d.resume.id] ? byId[d.resume.id].level : nf ? nf.n : 1;
  each('.hub-map__level', lv => setOpen(lv, !mqPhone.matches || +ga(lv, 'data-level') === def));
}
function initHome() {
  each('.hub-map__level', lv => {
    const b = q('.hub-map__toggle', lv);
    if (b) { b.hidden = false; on(b, 'click', () => setOpen(lv, ga(b, 'aria-expanded') !== 'true')); }
  });
  if (q('.hub-map__level', R)) { openDefaults(); onMq(mqPhone, openDefaults); }
  each('.hub-mythcard__btn[aria-controls]', b => {
    const r = D.getElementById(ga(b, 'aria-controls')), tog = open => { sa(b, 'aria-expanded', String(open)); r.hidden = !open; };
    if (!r) return;
    tog(false);
    on(b, 'click', () => tog(ga(b, 'aria-expanded') !== 'true'));
  });
  each('[data-hub-qc]', qc => {
    const bi = q('[data-hub-qc-in="boxPrice"]', qc), pi = q('[data-hub-qc-in="pieces"]', qc), out = q('[data-hub-qc-out]', qc), link = q('[data-hub-qc-link]', qc), note = q('[data-hub-qc-note]', qc), n0 = note && note.textContent;
    let t = 0;
    if (bi && pi) on(qc, 'input', () => { clearTimeout(t); t = setTimeout(() => {
      const b = num(bi.value), p = num(pi.value), good = b >= 0 && p >= 1;
      if (out) out.textContent = good ? '\u00a3' + (b / p).toFixed(2) + ' a piece' : 'Enter a box price and a piece count';
      if (note) tset(note, b === num(bi.defaultValue) && p === num(pi.defaultValue) ? n0 : 'Before fees and your other costs.');
      if (link && good) sa(link, 'href', withQ(hp + 'tools', 'boxPrice=' + b + '&pieces=' + p) + '#profit');
    }, 500); });
  });
}

function markLesson(id, fn) { store.set(s => { const e = s.lessons[id] || (s.lessons[id] = { s: 'started', pct: 0, at: 0 }); fn(e); e.at = Date.now(); s.last = id; }); }
function initLesson() {
  const L = q('.hub-lesson', R);
  if (!L || L.classList.contains('hub-lesson--stub') || !byId[ga(L, 'data-hub-lesson')]) return;
  const id = lid = ga(L, 'data-hub-lesson'), art = q('#hub-body', R) || q('.hub-prose', L), tape = q('.hub-bar__tape', R);
  let saved = (store.raw().lessons[id] || {}).pct || 0;
  if (art) {
    const tick = raf(() => {
      const r = art.getBoundingClientRect(), bh = barH(), den = r.height - (innerHeight - bh);
      const p = den <= 0 ? +(r.top <= bh) : clamp((bh - r.top) / den, 0, 1), pct = Math.round(p * 100);
      if (tape) tape.style.setProperty('--p', p.toFixed(4));
      // No render (the bar must not shift), consent only, never from a locked teaser.
      if (pct >= 10 && pct > saved && (saved < 10 || pct - saved >= 5 || pct === 100) && prefOK() && full()) { saved = pct; markLesson(id, e => { e.pct = Math.max(e.pct, pct); }); }
    });
    on(W, 'scroll', tick, PASS); on(W, 'resize', tick, PASS); on(D, 'visitorConsentCollected', tick); afterLayout(tick);
    tickL = tick;
  }
  initToc(L);
}

// A: all TOC parts. P: the headings on the page (rescanned after a view swap).
function initToc(L) {
  const det = q('.hub-toc__box', R), sum = det && q('summary', det), part = q('.hub-bar__part', R), hero = q('.hub-lhero', R), bar = q('.hub-bar', R), kind = ga(L, 'data-kind') === 'platform' ? 'playbook' : 'lesson';
  const list = q('.hub-toc__list', R), n = list ? qa('.hub-toc__a', list).length : 0, meta = byId[lid];
  let A = [], P = [], cur = -2, T = null, out = false;
  if (!n) return;
  if (sum) sum.append(' ', el('span', 'hub-toc__count', partsLabel(n) + (meta ? ', ' + meta.minutes + ' min' : '')));
  if (det) {
    const desk = () => { if (mqDesk.matches) { det.open = true; if (sum) sum.tabIndex = -1; } else if (sum) ra(sum, 'tabindex'); };
    onMq(mqDesk, desk); desk();
    on(sum, 'click', e => { if (mqDesk.matches) e.preventDefault(); });
  }
  function setCur(i) {
    if (i === cur) return;
    cur = i;
    const h = i > -1 && ga(P[i].a, 'href');
    A.concat(T ? qa('a', T.box) : []).forEach(a => (ga(a, 'href') === h ? sa(a, 'aria-current', 'true') : ra(a, 'aria-current')));
    tset(part && (q('.hub-bar__partt', part) || part), i < 0 ? 'In this ' + kind + ': ' + partsLabel(n) : 'Part ' + (A.indexOf(P[i].a) + 1) + ' of ' + n + ': ' + P[i].a.textContent.trim());
  }
  const spy = () => setCur(P.reduce((i, p, j) => (p.h.getBoundingClientRect().top <= innerHeight * 0.3 ? j : i), -1)), spyF = raf(spy);
  on(W, 'scroll', spyF, PASS); on(W, 'resize', spyF, PASS);
  const sync = () => { sa(R, 'data-hub-hero', out ? 'out' : 'in'); if (bar) bar.classList.toggle('is-part', out && P.length > 1 && !mqDesk.matches); };
  if (W.IntersectionObserver && hero) {
    new IntersectionObserver(en => { out = !en.pop().isIntersecting; sync(); }, { rootMargin: (mqDesk.matches ? -56 : -52) + 'px 0px 0px 0px' }).observe(hero);
    onMq(mqDesk, sync);
  }
  if (part) on(part, 'click', () => openToc(part));
  (tocScan = () => {
    // Pass view: locked rows link to their headings; visitor view restores them.
    if (pass()) qa('[data-hub-sec]', list).forEach(s => { const a = el('a', 'hub-toc__a', (q('.hub-toc__t', s) || s).firstChild.textContent, { href: '#' + ga(s, 'data-hub-sec') }); a.hubWas = s; s.replaceWith(a); });
    else qa('a', list).forEach(a => a.hubWas && a.replaceWith(a.hubWas));
    if (T) { T.d.remove(); T = null; }
    A = qa('.hub-toc__a', list);
    P = A.map(a => ({ a, h: idOf(a) })).filter(x => x.h && /^H\d$/.test(x.h.tagName)); cur = -2;
    hid(part, P.length < 2);
    each('.hub-secnav', b => { if (!b.hubH || !b.hubH.isConnected) b.remove(); });
    P.slice(1).forEach(p => {
      if (p.h.hubS) return;
      const b = el('button', 'hub-secnav', null, { type: 'button', 'aria-haspopup': 'dialog' });
      b.append(svg('hub-ico', 'use', { href: '#hub-i-list' }), el('span', null, 'Sections'));
      p.h.hubS = 1; b.hubH = p.h; on(b, 'click', () => openToc(b)); p.h.before(b);
    });
    sync(); afterLayout(spyF);
  })();
  function openToc(src) {
    if (!T) {
      T = mkDlg('hub-tocdlg', { 'aria-labelledby': 'hub-tocdlg-h' }, 'In this ' + kind);
      const dl = T.box.appendChild(q('.hub-toc__list', R).cloneNode(true)), c = cur;
      dl.className = 'hub-tocdlg__list';
      on(dl, 'click', e => {
        const a = hit(e, 'a'), h = a && idOf(a);
        if (!h) return;
        e.preventDefault(); T.drop(); T.d.close();
        if (!h.hasAttribute('tabindex')) sa(h, 'tabindex', '-1');
        h.scrollIntoView({ block: 'start', behavior: reduce.matches ? 'auto' : 'smooth' }); h.focus({ preventScroll: true });
        try { history.replaceState(null, '', '#' + h.id); } catch (err) { /* ignore */ }
      });
      cur = -2; setCur(c);
    }
    T.open(src);
    (q('a[aria-current]', T.box) || q('a', T.box)).focus();
  }
}

function initChecks() {
  on(R, 'change', e => {
    const t = e.target, box = t.classList.contains('hub-check__box') && t.closest('[data-hub-checklist]');
    if (!box) return;
    const key = ga(box, 'data-hub-checklist'), lk = key.split(':')[0];
    const ticked = qa('.hub-check__box', box).map((x, i) => (x.checked ? +(ga(x, 'data-i') || i) : -1)).filter(i => i > -1);
    store.set(s => {
      s.checks[key] = ticked;
      if (byId[lk] && ticked.length) { const l = s.lessons[lk]; if (l) l.at = Date.now(); else s.lessons[lk] = { s: 'started', pct: 0, at: Date.now() }; s.last = lk; }
    });
    render();
  });
}
// Per node, at boot and after a view swap.
function prep() {
  fadeWatch();
  once('[data-hub-checkcount]', 'hubL', c => { sa(c, 'aria-live', 'off'); setTimeout(() => sa(c, 'aria-live', 'polite'), 1500); });
  // done button, also a Pass part clone after a view swap (render sets aria-pressed)
  if (lid) once('.hub-done__btn', 'hubD', b => {
    if (!q('.hub-done__seam', b)) b.appendChild(svg('hub-done__seam', 'rect', { width: '100%', height: '100%', pathLength: '100' }));
    on(b, 'click', () => { const yes = ga(b, 'aria-pressed') !== 'true'; markLesson(lid, e => { e.s = yes ? 'done' : 'started'; if (yes) e.pct = 100; }); render(); });
    if (!store.ok()) tset(q('.hub-done__note', R), 'This browser is not saving data, so this lasts for this visit only.');
  });
  once('[data-hub-sources-more]', 'hubT', d => { const s = q('summary', d), t = s && s.textContent; on(d, 'toggle', () => tset(s, d.open ? 'Show fewer sources' : t)); });
}

function initBar() {
  const nav = q('.hub-bar__nav', R), cur = nav && q('[aria-current]', nav);
  let els = [], centre = !!cur, own = 0;
  const upd = list => {
    if (centre) { centre = false; const nr = nav.getBoundingClientRect(), cr = cur.getBoundingClientRect(); if (cr.left < nr.left || cr.right > nr.right) { nav.scrollLeft += cr.left - nr.left - (nr.width - cr.width) / 2; own = 1; } }
    const v = list.map(e => { const max = e.scrollWidth - e.clientWidth, x = Math.abs(e.scrollLeft); return max <= 1 ? 'none' : x <= 1 ? 'start' : x >= max - 1 ? 'end' : 'mid'; });
    list.forEach((e, i) => sx(e, 'data-scroll', v[i]));
  }, all = () => upd(els), o = W.ResizeObserver ? new ResizeObserver(all) : null;
  (fadeWatch = () => {
    els = els.filter(e => e.isConnected);
    [nav].concat(qa('.hub-table', R)).forEach(e => {
      if (!e || e.hubF) return;
      e.hubF = 1; els.push(e);
      if (o) { o.observe(e); if (e.firstElementChild) o.observe(e.firstElementChild); }
      on(e, 'scroll', raf(() => { if (e === nav && own) own = 0; else upd([e]); }), PASS); // skip our own centring scroll
    });
  })();
  // A focused nav link clears the fades (WCAG 2.4.7); snap off first.
  on(nav, 'focusin', e => {
    const s = nav.getBoundingClientRect(), a = e.target.getBoundingClientRect(), f = Math.min(36, (s.width - a.width) / 2);
    nav.style.scrollSnapType = 'none';
    nav.scrollLeft += a.left < s.left + f ? a.left - s.left - f : a.right > s.right - f ? a.right - s.right + f : 0;
  });
  if (/Mac|iPhone|iPad|iPod/.test(navigator.platform || '')) each('[data-hub-kbd]', k => { k.textContent = '\u2318 K'; });
}

// Fact popover on keyboard focus only (WCAG 1.4.13, no global Esc).
function initPop() {
  let pop = null, cur = null;
  const hide = () => { if (pop) pop.hidden = true; if (cur) ra(cur, 'aria-describedby'); cur = null; };
  function show(a) {
    if (!a.hasAttribute('data-source')) return;
    if (!pop) pop = R.appendChild(el('div', 'hub-pop', null, { id: 'hub-pop', role: 'tooltip' }));
    if (cur && cur !== a) ra(cur, 'aria-describedby');
    const est = a.classList.contains('hub-fact--estimate'), d = fmtDate(ga(a, 'data-checked'));
    cur = a; pop.textContent = '';
    pop.append(el('p', 'hub-pop__row', 'Source: ' + ga(a, 'data-source')), el('p', 'hub-pop__row', (est ? 'Rough estimate' + (d ? ', checked ' : '') : 'Checked ') + d));
    pop.hidden = false; sa(a, 'aria-describedby', 'hub-pop');
    const rs = Array.from(a.getClientRects()).filter(x => x.width), bar = q('.hub-bar', R), lim = (bar ? Math.max(0, bar.getBoundingClientRect().bottom) : 0) + 8;
    const op = pop.offsetParent || D.body, o = op.getBoundingClientRect(), f = rs[0] || a.getBoundingClientRect();
    let r = f, top = f.top - pop.offsetHeight - 8;
    if (top < lim) { r = rs[rs.length - 1] || f; top = r.bottom + 8; }
    pop.style.top = Math.round(top - o.top + op.scrollTop - op.clientTop) + 'px';
    pop.style.left = Math.round(clamp(r.left, 8, Math.max(8, D.documentElement.clientWidth - pop.offsetWidth - 8)) - o.left + op.scrollLeft - op.clientLeft) + 'px';
  }
  on(R, 'focusin', e => { const a = hit(e, '.hub-fact'); let fv = true; try { fv = a && a.matches(':focus-visible'); } catch (x) { /* old engines */ } if (a && fv) show(a); });
  on(R, 'focusout', e => { if (cur && e.target === cur) hide(); });
  on(R, 'keydown', e => { if (e.key === 'Escape' && cur && e.target === cur) hide(); });
  on(W, 'resize', hide, PASS);
}

// Open the collapsed sources before a jump into them and for print.
function initSources() {
  const reveal = h => {
    let t = null;
    try { t = h && h.length > 1 ? D.getElementById(decodeURIComponent(h.slice(1))) : null; } catch (e) { return null; }
    const d = t && t.closest('[data-hub-sources-more]');
    if (!d || d.open) return null;
    d.open = true; return t;
  };
  on(R, 'click', e => { const a = hit(e, 'a[href^="#hub-src-"]'); if (a) reveal(ga(a, 'href')); }, true);
  on(W, 'hashchange', () => { const t = reveal(location.hash); if (t) bring(t); });
  const t0 = reveal(location.hash);
  if (t0) afterLayout(() => bring(t0));
  let shut = [];
  on(W, 'beforeprint', () => { shut = qa('[data-hub-sources-more]', R).filter(d => !d.open); shut.forEach(d => { d.open = true; }); });
  on(W, 'afterprint', () => { shut.forEach(d => { d.open = false; }); shut = []; });
}

// Tools mount after the hash jump: re-align unless the reader moved.
function initHash() {
  let t = null;
  try { t = location.hash.length > 1 ? D.getElementById(decodeURIComponent(location.hash.slice(1))) : null; } catch (e) { t = null; }
  if (!t || !R.contains(t) || R.classList.contains('svw-hub--tools')) return;
  let moved = false;
  ['wheel', 'touchstart', 'keydown', 'pointerdown'].forEach(k => on(W, k, () => { moved = true; }, { once: true, passive: true }));
  realign = () => {
    if (moved || !t.getClientRects().length) return;
    const top = t.getBoundingClientRect().top, lim = parseFloat(getComputedStyle(t).scrollMarginTop) || barH() + 16;
    if (Math.abs(top - lim) > 8) W.scrollTo({ top: Math.max(0, top + W.pageYOffset - lim), behavior: 'instant' });
  };
  if (D.readyState === 'complete') setTimeout(realign, 50); else on(W, 'load', () => setTimeout(realign, 50), { once: true });
  setTimeout(realign, 1500);
}

function initPal() {
  let P = null, inp, list, empty, status, fbar, items = null, loading = null, failed = false, act = -1, opts = [], f = 'all', t = 0;
  function start() {
    const r = derive(store.raw(), idx).resume, L = byId[r.id] || (idx.lessons || [])[0];
    return (L ? [{ g: 'lesson', t: L.title, s: r.mode === 'resume' ? 'Pick up where you left off' : 'Up next in the School', u: hp + L.id, p: lockOf(idx.lessons)(L) }] : []).concat(
      { g: 'page', t: 'The Toolkit', s: (idx.tools || []).length + ' calculators and builders', u: hp + 'tools' }, { g: 'page', t: 'Glossary', s: 'Plain-English meanings for reselling terms', u: hp + 'glossary' });
  }
  function load() {
    const u = ga(R, 'data-hub-search-data');
    if (items || loading) return;
    if (!u || !W.fetch) { failed = true; return; }
    failed = false;
    loading = fetch(u, { credentials: 'same-origin' }).then(r => { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(j => { items = buildIndex(j || {}, hp); }, () => { failed = true; }).then(() => { loading = null; if (P.d.open) draw(); });
  }
  function move(i) {
    if (!opts.length) return;
    if (opts[act]) sa(opts[act].e, 'aria-selected', 'false');
    act = (i + opts.length) % opts.length;
    const o = opts[act].e;
    sa(o, 'aria-selected', 'true'); sa(inp, 'aria-activedescendant', o.id); o.scrollIntoView({ block: 'nearest' });
  }
  const go = o => { if (o) { P.d.close(); location.href = o.u; } };
  function draw() {
    const qv = inp.value.trim(), ts = toks(qv);
    let msg = '';
    list.textContent = ''; empty.textContent = ''; opts = []; act = -1; ra(inp, 'aria-activedescendant');
    (!ts.length && f === 'all' ? [{ label: 'Start here', items: start() }] : items ? search(items, qv, f) : []).forEach(g => {
      list.appendChild(el('li', 'hub-pal__grp', g.label, { 'aria-hidden': 'true' }));
      g.items.forEach(it => {
        const li = list.appendChild(el('li', 'hub-pal__opt', null, { role: 'option', id: 'hub-pal-o' + opts.length, 'aria-selected': 'false' })), tt = el('span', 'hub-pal__t'), o = { e: li, u: it.u };
        let at = 0;
        ranges(it.t, ts).forEach(r => { tt.append(it.t.slice(at, r[0]), el('mark', null, it.t.slice(r[0], r[1]))); at = r[1]; });
        tt.append(it.t.slice(at));
        if (it.p && !pass()) tt.append(' ', el('span', 'hub-chip hub-pal__pass', 'Pass', { 'aria-hidden': 'true' }), el('span', 'visually-hidden', ', part of the Reseller Pass'));
        li.append(tt, el('span', 'hub-pal__s', it.s), el('span', 'hub-pal__k', KIND[it.g]));
        on(li, 'click', () => go(o)); opts.push(o);
      });
    });
    if (!opts.length) {
      if (failed) empty.append(msg = 'Search could not load.', ' ', el('a', null, 'Browse the School instead.', { href: hh + '#school' }));
      else if (!items) empty.append(msg = 'Loading the search index.');
      else {
        empty.append(msg = 'Nothing matches that yet. Try a shorter word.');
        if (bob && qv) {
          const b = el('button', 'hub-ask hub-pal__ask', null, { type: 'button' });
          b.append(el('span', 'hub-ask__k', 'Ask Bob'), ' ', el('span', 'hub-ask__q', qv.slice(0, 120)), el('span', 'visually-hidden', ' (Bob is our automated assistant)'));
          on(b, 'click', () => { P.d.close(); ask(qv); }); empty.append(' ', b);
        }
      }
    }
    empty.hidden = !!opts.length; list.hidden = !opts.length;
    sa(inp, 'aria-expanded', String(!!opts.length));
    status.textContent = opts.length ? opts.length + (opts.length > 1 ? ' results' : ' result') : msg;
  }
  const syncF = () => qa('button', fbar).forEach(b => sa(b, 'aria-pressed', String(ga(b, 'data-f') === f)));
  function build() {
    P = mkDlg('hub-pal', { 'aria-label': 'Search the Reseller Hub' });
    inp = el('input', 'hub-pal__input', null, { id: 'hub-pal-in', type: 'text', role: 'combobox', 'aria-expanded': 'false', 'aria-controls': 'hub-pal-list',
      'aria-autocomplete': 'list', autocomplete: 'off', spellcheck: 'false', placeholder: 'Search lessons, tools, terms' });
    P.head.prepend(svg('hub-ico', 'use', { href: '#hub-i-search' }), el('label', 'visually-hidden', 'Search lessons, tools, playbooks and terms', { for: 'hub-pal-in' }), inp);
    fbar = el('div', 'hub-pal__filters', null, { role: 'group', 'aria-label': 'Show' });
    'all:All lesson:Lessons tool:Tools playbook:Playbooks term:Terms'.split(' ').forEach(p => {
      const [v, label] = p.split(':');
      on(fbar.appendChild(el('button', 'hub-pal__f', label, { type: 'button', 'data-f': v })), 'click', () => { f = v; syncF(); draw(); inp.focus(); });
    });
    list = el('ol', 'hub-pal__list', null, { id: 'hub-pal-list', role: 'listbox', 'aria-label': 'Results', tabindex: '-1' });
    empty = el('p', 'hub-pal__empty'); status = el('p', 'visually-hidden', null, { role: 'status' });
    P.box.append(fbar, list, empty, status, el('p', 'hub-pal__foot', 'Arrow keys to move, Enter to open, Esc to close', { 'aria-hidden': 'true' }));
    on(inp, 'input', () => { clearTimeout(t); t = setTimeout(draw, 60); });
    on(P.d, 'keydown', e => {
      const k = e.key;
      if (e.isComposing) return;
      if (k === 'ArrowDown' || k === 'ArrowUp') { e.preventDefault(); move(act < 0 && k === 'ArrowUp' ? -1 : act + (k === 'ArrowDown' ? 1 : -1)); }
      else if ((k === 'Home' || k === 'End') && opts.length && (act > -1 || e.target !== inp)) { e.preventDefault(); move(k === 'Home' ? 0 : -1); }
      else if (k === 'Enter' && e.target === inp) { e.preventDefault(); if (act < 0) { clearTimeout(t); draw(); } go(opts[Math.max(act, 0)]); }
    });
  }
  function open(src) {
    if (!P) build();
    if (P.d.open) return;
    each('dialog[open]', d => d.close());
    inp.value = ''; f = 'all'; syncF(); P.open(src); draw(); inp.focus(); load();
  }
  each('[data-hub-search]', b => on(b, 'click', e => { e.preventDefault(); open(b); }));
  // Ctrl/Cmd+K only: a bare "/" shortcut fails WCAG 2.1.4.
  on(D, 'keydown', e => {
    if (!e.defaultPrevented && (e.key === 'k' || e.key === 'K') && (e.ctrlKey || e.metaKey) && !e.altKey && !e.shiftKey) { e.preventDefault(); if (P && P.d.open) P.d.close(); else open(); }
  });
}

function initGloss() {
  const G = q('[data-hub-gloss]', R);
  if (!G) return;
  const inp = q('[data-hub-gq]', R), cnt = q('.hub-gcount', R), none = q('[data-hub-gloss-none]', G), az = qa('.hub-az button', R), src = q('.hub-sources', R);
  const secs = qa('.hub-gloss__sec', G).map(s => ({ s, items: qa('.hub-gloss__item', s).map(e => ({ e, t: norm(ga(e, 'data-term')) })) }));
  const letterOf = b => { const l = (ga(b, 'data-hub-letter') || b.textContent).trim().toLowerCase(); return l === 'all' ? '' : l; };
  let letter = '', t = 0, total = 0;
  secs.forEach(x => { total += x.items.length; });
  if (none) none.textContent = 'No matches. Try a shorter word.';
  if (inp && !inp.value) try { inp.value = (new URLSearchParams(location.search).get('q') || '').slice(0, 80); } catch (e) { /* old engines */ }
  function apply() {
    const qv = inp ? inp.value.trim() : '', ts = toks(qv);
    let n = 0;
    secs.forEach(x => {
      let k = 0;
      x.items.forEach(i => { const show = (!letter || i.t.charAt(0) === letter) && ts.every(w => i.t.indexOf(w) > -1); i.e.hidden = !show; k += show; });
      x.s.hidden = !k; n += k;
    });
    tset(cnt, letter || ts.length ? (n === 1 ? '1 match' : n + ' matches') : total + ' terms');
    each('[data-hub-ask-from]', b => tset(q('.hub-ask__q', b), askText(b)));
    if (none) none.hidden = n > 0;
    if (src) src.hidden = !n;
  }
  az.forEach(b => on(b, 'click', () => {
    if (ga(b, 'aria-disabled') === 'true') return;
    letter = letterOf(b); az.forEach(x => sa(x, 'aria-pressed', String(letterOf(x) === letter))); apply();
  }));
  on(inp, 'input', () => { clearTimeout(t); t = setTimeout(apply, 120); });
  on(inp && inp.form, 'submit', e => { e.preventDefault(); clearTimeout(t); apply(); });
  apply();
}

function downloadCsv() {
  const t = qa('.hub-prose--page table', R).find(x => /^date$/i.test(tget(q('th', x))));
  if (!t) return;
  const a = el('a', null, null, { download: 'reseller-hub-records.csv', href: 'data:text/csv;charset=utf-8,' + encodeURIComponent('\ufeff' + qa('tr', t).map(r => Array.from(r.cells, c => '"' + c.textContent.trim().replace(/"/g, '""') + '"').join(',')).join('\r\n')) });
  D.body.appendChild(a); a.click(); a.remove();
}
function initClicks() {
  on(R, 'click', e => {
    const b = hit(e, '[data-hub-print], [data-hub-csv], [data-hub-reset], [data-hub-ask]');
    if (!b) return;
    e.preventDefault();
    if (b.hasAttribute('data-hub-ask')) ask(askText(b), ga(b, 'data-hub-ask-lesson') || lid);
    else if (b.hasAttribute('data-hub-print')) print();
    else if (b.hasAttribute('data-hub-csv')) downloadCsv();
    else if (confirm('Reset your progress on this device? This clears lessons read or done, checklist ticks and patches.')) {
      store.set(s => { s.lessons = {}; s.last = null; s.checks = {}; s.patches = []; });
      render(); openDefaults(); toast('Progress reset on this device');
    }
  });
}

function initBob() {
  // hub:lesson: emit, or queue in SVWBobPending for Bob's boot.
  if (lid) {
    const d = { id: lid, url: location.pathname + location.search }, b = W.SVWBob;
    if (b && b.ready && b.events) { try { b.events.emit('hub:lesson', d); } catch (e) { /* Bob's */ } }
    else { try { (W.SVWBobPending = W.SVWBobPending || []).push({ type: 'hub:lesson', data: d }); } catch (e) { /* ignore */ } }
  }
  const go = () => {
    const b = W.SVWBob;
    if (bob || !b || (b.config && b.config.enabled === false)) return;
    bob = true; revealAsk();
  };
  if (W.SVWBob && W.SVWBob.ready) go(); else on(D, 'svwbob:ready', go, { once: true });
}
function initTools() {
  const page = R.classList.contains('svw-hub--tools') || ga(R, 'data-hub-page') === 'tools';
  const mount = () => { try { if (W.SVWHubTools) W.SVWHubTools.mountAll(D); } catch (e) { /* tools' */ } revealAsk(); raf(realign)(); };
  const add = (u, cb) => { if (u) { const s = el('script', null, null, { src: u }); s.async = false; s.onload = cb; D.head.appendChild(s); } };
  const run = () => (W.SVWHubCalc ? add(ga(R, 'data-hub-tools-js'), mount) : add(ga(R, 'data-hub-calc-js'), () => add(ga(R, 'data-hub-tools-js'), mount)));
  if (W.SVWHubTools) return void mount();
  if (toolsReq || (!page && !q('[data-hub-tool]'))) return;
  toolsReq = true;
  if (page || !W.requestIdleCallback) setTimeout(run, page ? 0 : 300); else requestIdleCallback(run, { timeout: 2000 });
}
// Preview-only toggles, at the top, never in localStorage.
function grp(cls, label, name, opts, cur, pick) {
  const g = el('span', cls, label, { role: 'group', 'aria-label': name });
  opts.forEach(([v, t]) => {
    const b = g.appendChild(el('button', null, t, { type: 'button', 'aria-pressed': String(v === cur) }));
    on(b, 'click', () => { qa('button', g).forEach(x => sa(x, 'aria-pressed', String(x === b))); pick(v); });
  });
  return g;
}
function initQA() {
  if (ga(R, 'data-hub-mode') !== 'preview' || !/[?&]hubqa=1(&|$)/.test(location.search)) return;
  const bar = q('.hub-bar', R), g = grp('hub-qa hub-on-ink', 'QA state:', 'Preview QA state, not saved', [['new', 'New visitor'], ['mid', 'Mid-way'], ['all', 'All done']], '', v => { store.load(qaState(v, idx)); render(); openDefaults(); });
  if (bar) underBar(bar, g, '.8rem'); else R.prepend(g);
}
function underBar(bar, e, gap) { bar.appendChild(e); e.style.position = 'absolute'; e.style.top = 'calc(100% + ' + gap + ')'; }

// Pass holder: clone each paid-preview template in place, hide its [data-hub-lock]. Visitor: remove the clones.
function swap(v) {
  const ids = [];
  view = v; sx(R, 'data-hub-view', v);
  each('template[data-hub-paid-preview]', t => { (t.hubN || []).forEach(n => n.remove()); t.hubN = null; });
  // one at a time, so a template nested in paid content (a tool in a lesson's paid part) is swapped in too
  for (let t; v === 'pass' && (t = qa('template[data-hub-paid-preview]', R).find(x => !x.hubN));) {
    const f = t.content.cloneNode(true);
    t.hubN = Array.from(f.childNodes); t.before(f); ids.push(ga(t, 'data-hub-for'));
  }
  each('[data-hub-lock]', e => hid(e, ids.indexOf(ga(e, 'data-hub-lock')) > -1));
  // tools JS also reads data-hub-view on mount
  try { D.dispatchEvent(new CustomEvent('hub:view', { detail: { view: v, pass: pass() } })); } catch (e) { /* old engines */ }
}
function setView(v) {
  if (v === view) return;
  swap(v);
  try { W.sessionStorage.setItem(VKEY, v); } catch (e) { /* ignore */ }
  [tocScan, prep, render, revealAsk, initTools, tickL].forEach(f => { try { f(); } catch (e) { /* keep going */ } });
  toast('Preview: viewing as a ' + (v === 'pass' ? 'Pass holder' : 'visitor'));
}
// In the draft strip: top of the page, in flow, never over content.
function initView() {
  if (!canView(ga(R, 'data-hub-mode'), ga(R, 'data-hub-entitled'))) return;
  swap(viewOf(() => W.sessionStorage.getItem(VKEY)));
  const g = grp('hub-viewas', 'View as:', 'Preview only: view the hub as', [['visitor', 'Visitor'], ['pass', 'Pass holder']], view, setView), d = q('.hub-draft', R);
  if (d) d.appendChild(g); else R.prepend(g);
}

function boot() {
  if (!D || W.SVWHub) return;
  if (D.readyState === 'loading') return void on(D, 'DOMContentLoaded', boot, { once: true });
  R = q('.svw-hub');
  if (!R || R.classList.contains('is-ready')) return;
  try { idx = JSON.parse(q('#svw-hub-index').textContent) || {}; } catch (e) { idx = {}; }
  (idx.lessons || []).forEach(l => { byId[l.id] = l; });
  hp = ga(R, 'data-hub-hp') || ''; hh = ga(R, 'data-hub-hh') || '';
  store = mkStore(() => W.localStorage);
  reduce = mq('(prefers-reduced-motion: reduce)'); mqPhone = mq('(max-width: 749px)'); mqDesk = mq('(min-width: 990px)');
  if (rg('go') || rg('t')) rco = { k: tget(rg('k')), n: tget(rg('n')), t: tget(rg('t')), m: tget(rg('m')), note: tget(rg('note')), gt: tget(rg('go')), gh: rg('go') && ga(rg('go'), 'href') };
  const bar = q('.hub-bar', R);
  toastEl = el('div', 'hub-toast hub-on-ink', null, { role: 'status' });
  if (bar) underBar(bar, toastEl, '1.2rem'); else R.appendChild(toastEl);
  W.SVWHub = { store: { get: store.get, set: fn => { store.set(fn); render(); }, ok: store.ok }, toast, ask, bobReady: () => bob, pass, view: () => view };
  // initView first: a saved Pass view swaps in before the rest.
  [initView, initBar, initClicks, initLesson, initChecks, prep, initHome, render, initPal, initGloss, initPop, initSources, initHash, initQA, initBob, initTools].forEach(fn => {
    try { fn(); } catch (e) { if (W.console) console.warn('[svw-hub] ' + fn.name + ' failed', e); }
  });
  on(W, 'pagehide', store.flush);
  on(D, 'visibilitychange', () => { if (D.visibilityState === 'hidden') store.flush(); });
  R.classList.add('is-ready');
}

return { KEY, VKEY, parse, mkStore, derive, pickResume, buildIndex, score, search, ranges, toks, norm, fmtDate, withQ, qaState, glossAsk, canView, viewOf, partsLabel, lockOf, boot };
});
